
type STYPE = 'inner' | 'outer'
// 系统类型，区分内外包项目
let $sType = 'inner'

function setSType(type: STYPE) {
    $sType = type
}

export {
    $sType,
    setSType
}
